var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lm-wait"}},[_c('LmSelect',{attrs:{"options":_vm.options},model:{value:(_vm.optionSelected),callback:function ($$v) {_vm.optionSelected=$$v},expression:"optionSelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }